<template>
  <div>
    <v-text-field
      outlined
      dense
      type="text"
      :label="placeholder"
      :name="name"
      v-model="value"
      v-mask="'####'"
      @change="updateValue"
      :error-messages="error"
      :disabled="disabled"
      :readonly="readOnly"
      :ref="name"
    ></v-text-field>
  </div>
</template>

<script>
export default {
  name: "SGPFormAnoComponent",

  props: {
    placeholder: {
      type: String,
      required: false,
      default: "Ano"
    },
    name: {
      type: String,
      required: true,
    },

    parse: {
      type: Boolean,
      required: false,
      default: true,
    },

    value: {
      type: [String, Number],
      required: true,
      default: ''
    },

    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },

    disabled: {
      type: Boolean,
      required: false,
      default: false
    },

    error: {
      type: Boolean,
      required: false,
      default: false
    }
  },

  methods: {
    updateValue () {
      this.$emit('input', this.value)
      this.$emit('change', this.value)
    }
  }
}
</script>
